import { render, staticRenderFns } from "./BizInsuranceWithTypeList.vue?vue&type=template&id=1b106437&"
import script from "./BizInsuranceWithTypeList.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceWithTypeList.vue?vue&type=script&lang=js&"
import style0 from "./BizInsuranceWithTypeList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports